// Shared helpers for interpreting database errors.

/**
 * True if a thrown Supabase/Postgres error is a unique-constraint violation
 * (SQLSTATE 23505). Used to turn "duplicate code" DB errors into friendly
 * messages in forms.
 */
export function isUniqueViolation(err: unknown): boolean {
  return !!err && typeof err === "object" && (err as { code?: string }).code === "23505";
}

/**
 * Safely extract a human-readable message from an unknown caught value.
 * Use in `catch (err: unknown)` blocks instead of reaching into `err.message`.
 */
export function getErrorMessage(err: unknown, fallback = "Something went wrong."): string {
  if (typeof err === "string" && err) return err;
  if (err && typeof err === "object" && "message" in err) {
    const m = (err as { message?: unknown }).message;
    if (typeof m === "string" && m) return m;
  }
  return fallback;
}
